import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchSchoolMissions,teacherUpdateSchoolMissionNew } from '../../services2/schoolMissions.service';
import { teacherFetchUserList } from '../../services2/users.service.js';
import { useSetting } from '../../util/useSetting.js';



function Component(props) {
    const { fontSize } = useSetting();
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(0)

    const [classList, setClassList] = useState([
    ])


    const filter = searchParams.get('filter') || '全部';
    const status = searchParams.get('status') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }

    const fetchData = async (force = false) => {
        const filter = {}
        if (status !== '全部') filter.status = status
        let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        if (result.result) {
            setdata(result.result)
            settotal(result.count || 0)
        } else {
            alert('Fetch data error')
        }
    }

    const [students, setStudents] = useState([])
    const fetchStudents = async () => {
        let result = await teacherFetchUserList(props.token.token, { type: 'student' }, { limit: 9999, sort: { name: 1 } });
        if (result.result) {
            setStudents(result.result || [])
        } else {
            console.log('Fetch data error')
        }
    }
    useEffect(() => {
        let class_list = []
        for(let student of students) {
            if(student.class && !class_list.includes(student.class)) {
                class_list.push(student.class)
            }
        }
        setClassList(class_list.map(name => ({ name })))
    },[students])


    const onSelectFilter = (item, index) => {
        searchParams.delete('filter')
        searchParams.delete('page')
        searchParams.set('filter', item)
        searchParams.set('page', 1)
        setSearchParams(searchParams)
    }

    const selectStatusFilter = (s) => () => {
        searchParams.delete('status')
        searchParams.delete('page')
        searchParams.set('status', s)
        searchParams.set('page', 1)
        setSearchParams(searchParams)
    }


    useEffect(() => {
        refreshData()
    }, [searchParams])

    async function refreshData() {
        await fetchData()
        await fetchStudents()
    }


    let handleSave = (schoolMission,index)=>async ()=>{
        let result = await teacherUpdateSchoolMissionNew(props.token.token,schoolMission?._id, { classes: data[index]?.classes });
        if(result.result) {
            alert('更新成功')
        } else {
            alert('更新失敗')
        }
        await refreshData()
    }



    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex p-[16px] gap-[16px]' style={{ fontSize: fontSize, backgroundImage: 'url(/secondary/bg4.png)', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-row items-center justify-between items-center flex-wrap'>
                <div className='text-[#4B555C] font-[900]' style={{ fontSize: fontSize + 4 }}>派發管理</div>
            </div>

            {/*list of data*/}
            <div className='flex flex-col flex-1 w-full p-[16px] noto-san-hk font-[600]'>
                {data?.map((item, index) =>
                    <div key={item?._id || index} className='w-full flex flex-col justify-between items-center rounded-[12px]' style={{ background: 'linear-gradient(to right, #003A57, #108B96)' }}>
                        <div className='px-[16px] py-[8px] text-white w-full text-left font-[700]'>
                            {item?.mission?.name}
                        </div>
                        <div className='flex flex-col w-full justify-start p-[16px] rounded-[12px]' style={{ background: 'linear-gradient(to bottom, #F0FBFF, #FFFFFF)' }}>
                            <div className='w-full flex flex-row items-stretch gap-[32px]'>
                                <div className='flex-1 flex flex-col gap-[16px] justify-start'>
                                    <div className='w-full flex flex-row gap-[16px] items-center justify-start'>
                                        <div>所有班級</div>
                                        <ToggleButton value={item?.classes?.length === classList.length} onClick={() => {
                                            let newValue = !(item?.classes?.length === classList.length);
                                            setdata(prevData => {
                                                let newData = [...prevData];
                                                newData[index].classes = newValue ? classList.map(cls => cls.name) : [];
                                                return newData;
                                            });
                                            let newClassList = classList.map(cls => ({ ...cls, selected: newValue }));
                                            setClassList(newClassList);
                                        }} />
                                    </div>
                                    <div className='flex flex-row w-full justify-start gap-[24px] flex-wrap'>
                                        {classList.map((cls, clsIndex) => (
                                            <div key={clsIndex} className='flex flex-row gap-[32px] items-center justify-start'>
                                                <div>{cls.name}:</div>
                                                <ToggleButton value={ (item.classes||[]).includes(cls.name)} onClick={() => {
                                                    if ((item.classes||[]).includes(cls.name)) {
                                                        setdata(prevData => {
                                                            let newData = [...prevData];
                                                            newData[index].classes = (newData[index].classes||[]).filter(c => c !== cls.name);
                                                            return newData;
                                                        });
                                                    } else {
                                                        setdata(prevData => {
                                                            let newData = [...prevData];
                                                            newData[index].classes = [...(newData[index].classes||[]), cls.name];
                                                            return newData;
                                                        });
                                                    }
                                                }} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className='flex-1 flex flex-col gap-[16px] justify-start'>
                                    <div>班級</div>
                                    <div className='flex flex-row justify-start w-full gap-[24px] items-center'>
                                        <div className='min-w-[200px]'>總平均：65/100 分</div>
                                        <div className='flex-1 h-[13px] bg-[#00000020] rounded-full relative overflow-hidden'>
                                            <div className='h-full bg-[#178E95] rounded-full' style={{ width: '65%' }}></div>
                                        </div>
                                    </div>
                                    <div className='flex flex-row justify-start w-full gap-[24px] items-center'>
                                        <div className='min-w-[200px]'>完成率：89% (80/120)</div>
                                        <div className='flex-1 h-[13px] bg-[#00000020] rounded-full relative overflow-hidden'>
                                            <div className='h-full bg-[#178E95] rounded-full' style={{ width: '89%' }}></div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='flex flex-row justify-start w-full p-[16px] mt-[24px]'>
                                <button onClick={handleSave(item,index)} className='bg-[#178E95] text-white px-[64px] py-[6px] rounded-full' style={{ fontSize: fontSize - 2 }}>
                                    儲存
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {/*end of list of data*/}
            <PageSelector
                handleSelectPage={handleSelectPage}
                page={page}
                total={total}
                totalPage={totalPage}
            />
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)



function ToggleButton({ onClick, value = false }) {
    return (
        <button onClick={onClick} className='gap-[4px] text-white px-[14px] py-[1px] rounded-full flex flex-row items-center' style={{
            backgroundColor: value ? '#03839F' : '#00000030'
        }}>
            <div className='w-[16px] h-[16px] rounded-full' style={{ background: 'linear-gradient(to bottom, #BEBEBE70, #F0FBFF)', opacity: value ? 0 : 1 }} />
            {value ? '開' : '關'}
            <div className='w-[16px] h-[16px] rounded-full' style={{ background: 'linear-gradient(to right, #015B6B, #00E9BA)', opacity: value ? 1 : 0 }} />
        </button>
    );
}